import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { FormattedDistance } from 'shared/units'
import styles from './_routeItem.css'

function RouteItem ({ route, onClick, className }) {
  const isPublic = route && route._links.privacy[0].id === '3'
  return (
    <div className={classnames(styles.container, className)} onClick={onClick}>

      <div className={styles.thumbnail}>
        <img
          className={styles.thumbnailImage}
          src={route._links.thumbnail[0].href}
        />
      </div>

      <div className={styles.distance}>
        <FormattedDistance
          id='routes.my_routes_module.row.distance'
          value={route.distance}
          digits={2}
        />
      </div>

      <div className={styles.info}>
        <a
          className={styles.name}
          href={isPublic ? `/routes/view/${route._links.self[0].id}/` : null}
        >
          {route.name}
        </a>
        <div className={styles.location}>
          <FormattedMessage
            id='routes.my_routes_module.row.location'
            defaultMessage='{city}, {state}, {country}'
            values={{
              city: route.city,
              state: route.state,
              country: route.country && route.country.toUpperCase(),
            }}
          />
        </div>
      </div>

    </div>
  )
}

RouteItem.propTypes = {
  route: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default RouteItem



// WEBPACK FOOTER //
// ./src/components/routes/RouteSelector/RouteItem.jsx